import React, { useState, useEffect } from "react";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { blogBreadcrumb, defBreadcrumb } from "../../data/DataBreadcrumb";
import BlogList from "../../components/IndexPage/BlogList";
import { blogMeta } from "../../data/DataMetatags";
import { blogCategory, BlogTitle } from "../../data/DataBlog";
import Link from "next/link";
import { GACustomEvent } from "src/utils/analytics";

const Blog = (props) => {
  const { path, title, description, breadcrumb, blogBreadcrumb } = props;
  let data;
  const [popularList, setPopularList] = useState(data);

  const [isLoadingList, setIsLoadingList] = useState(false);

  const blogList = [];

  blogCategory.forEach((data) => {
    blogList.push(data);
  });

  useEffect(() => {
    GACustomEvent("blog_page", "view");
  }, []);

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={blogBreadcrumb} maxWidth="914px" />
      <Wrapper>
        {blogCategory.map((data, key) => {
          return (
            <div className="blog-list-wrapper" key={key}>
              {data.codename !== "terpopuler" && (
                <div className="section-title-wrapper">
                  <Link
                    href="/blog/[blog-category]"
                    as={`/blog/${BlogTitle[data.codename].slug}`}
                  >
                    <a className="section-title">
                      {data.codename !== "terbaru" ? data.name : "Artikel Baru"}
                    </a>
                  </Link>
                  {data.codename !== "terbaru" && (
                    <Link
                      href="/blog/[blog-category]"
                      as={`/blog/${BlogTitle[data.codename].slug}`}
                    >
                      <a className="lihat-semua">Lihat Semua</a>
                    </Link>
                  )}
                </div>
              )}
              <div className="blog-list-container">
                <BlogList
                  activeList={data.codename === "terbaru" ? "" : data.codename}
                  isLoadingList={isLoadingList}
                  setIsLoadingList={setIsLoadingList}
                  setPopularList={setPopularList}
                />
                {data.codename === "terbaru" && (
                  <div className="artikel-populer-wrapper">
                    <p
                      style={{
                        fontSize: "17px",
                        color: "#676767",
                        fontWeight: "bold"
                      }}
                    >
                      Artikel Terpopuler
                    </p>
                    <div className="artikel-populer-items">
                      {popularList &&
                        popularList.item.map((data, key) => (
                          <Link href={`/${data.slug}`}>
                            <a
                              key={key}
                              style={{
                                fontSize: "14px",
                                color: "#404040",
                                fontWeight: "bold",
                                margin: "8px 0"
                              }}
                            >
                              {data.title}
                            </a>
                          </Link>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Wrapper>
      <style jsx>{`
        .blog-list-wrapper {
          width: 100%;
        }
        .blog-list-container {
          display: flex;
        }
        .artikel-populer-wrapper {
          max-width: 306px;
          margin-left: 32px;
        }
        .artikel-populer-wrapper p {
          border-bottom: 1px solid #404040;
          margin-top: -7px;
        }
        .artikel-populer-items {
          display: flex;
          flex-direction: column;
        }
        .artikel-populer-items a {
          border-bottom: 1px solid #c8c8c8;
        }
        .section-title {
          color: #000000;
          font-weight: bold;
          margin: 16px 0;
          font-size: 24px;
        }
        .section-title-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 12px;
        }
        .lihat-semua {
          font-weight: bold;
          font-size: 16px;
          line-height: 16px;
          color: #e11931;
          margin: 16px;
        }
        @media only screen and (max-width: 978px) {
          .section-title {
            margin: 16px;
          }
        }
        @media only screen and (max-width: 600px) {
          .blog-list-container {
            flex-direction: column;
          }
          .artikel-populer-wrapper {
            margin-left: 16px;
          }
          .artikel-populer-wrapper p {
            margin-top: 1em;
          }
          .section-title {
            font-size: 20px;
          }
          .section-title-wrapper {
            margin-left: 0;
          }
          .lihat-semua {
            font-size: 10px;
          }
        }
      `}</style>
    </Layout>
  );
};

export const Wrapper = ({ children }) => {
  return (
    <div className="container">
      <div className="wrapper">{children}</div>
      <style jsx>{`
        .container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          max-width: 940px;
          width: 100%;
          align-items: center;
        }
      `}</style>
    </div>
  );
};

export const getStaticProps = () => {
  const { title, description, path } = blogMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];
  return {
    props: {
      path,
      title,
      description,
      breadcrumb,
      blogBreadcrumb
    }
  };
};

export default Blog;
